import reactImg from '../../img/react.jpg';
import udemyImg from '../../img/udemy.jpg';
import amazonImg from '../../img/amazon.png';
import metaImg from '../../img/meta.png';
import tiktokImg from '../../img/tiktok.jpg';
import githubImg from '../../img/github.jpg';

const postData = [
  {
    id: 1,
    avatar: reactImg,
    name: 'React News',
    followers: '500.643',
    posted: '1h',
    text: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Iste, nisi.',
    likes: '4.235',
    comments: '23',
    shares: '12',
  },
  {
    id: 2,
    avatar: udemyImg,
    name: 'Udemy',
    followers: '750.395',
    posted: '1.5h',
    text: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Iste, nisi.',
    likes: '493',
    comments: '15',
    shares: '32',
  },
  {
    id: 3,
    avatar: amazonImg,
    name: 'Amazon',
    followers: '975.226',
    posted: '2h',
    text: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Iste, nisi.',
    likes: '726',
    comments: '230',
    shares: '24',
  },
  {
    id: 4,
    avatar: metaImg,
    name: 'Meta Careers',
    followers: '1.230',
    posted: '3h',
    text: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Iste, nisi.',
    likes: '623',
    comments: '65',
    shares: '20',
  },
  {
    id: 5,
    avatar: tiktokImg,
    name: 'TikTok',
    followers: '698.265',
    posted: '2.5h',
    text: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Iste, nisi.',
    likes: '7.265',
    comments: '1560',
    shares: '6.356',
  },
  {
    id: 6,
    avatar: githubImg,
    name: 'Github',
    followers: '9.365',
    posted: '4h',
    text: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Iste, nisi.',
    likes: '635',
    comments: '60',
    shares: '50',
  },
];

export default postData;
